export default "__VITE_ASSET__ad0WpDPk__"